// import React, { useState, useEffect } from 'react';
// import { Save, X } from 'lucide-react';
// import { useNavigate } from 'react-router-dom';
// import config from '../../config';
// import axios from 'axios';

// const ArchitectureDesignerPageManage = () => {
//   const navigate = useNavigate();

//   const [activeLanguage, setActiveLanguage] = useState('en');
//   const [contentId, setContentId] = useState(null);
//   const [isNewContent, setIsNewContent] = useState(false);

//   // English (default) form data
//   const [formData, setFormData] = useState({
//     hero: {
//       title: '',
//       subtitle: '',
//       paragraphs: [''],
//     },
//     statistics: {
//       ledStrips: { number: '',description:'' },
//       retailSpace: { number: '',description:'' },
//     },
//     navigation: {
//       aboutUs: '',
//       ourTeam: '',
//     },
//     textBanner: {
//       title: '',
//       paragraphs: [''],
//     },
//     textBanner2: {
//       title: '',
//       paragraphs: [''],
//     },
//     sections: {
//       whatWeOffer: '',
//       ourProcess: '',
//     },
//     offers: [{ icon: '', title: '', desc: '' }],
//     process: [{ icon: '', title: '', desc: '' }],
//     disclaimer: {
//       title: '',
//       text: '',
//     },
//     section3: {
//       title: '',
//       paragraphs: [''],
//     },
//   });

//   // Upload files (optional)
//   const [heroVideoFile, setHeroVideoFile] = useState(null);
//   const [textBannerImageFile, setTextBannerImageFile] = useState(null);
//   const [textBanner2ImageFile, setTextBanner2ImageFile] = useState(null);
//   const [disclaimerVideoFile, setDisclaimerVideoFile] = useState(null);

//   // Spanish translation form data
//   const [spanishData, setSpanishData] = useState({
//     hero: {
//       title: '',
//       subtitle: '',
//       paragraphs: [''],
//     },
//     statistics: {
//       ledStrips: { number: '' ,description:''},
//       retailSpace: { number: '',description:'' },
//     },
//     navigation: {
//       aboutUs: '',
//       ourTeam: '',
//     },
//     textBanner: {
//       title: '',
//       paragraphs: [''],
//     },
//     textBanner2: {
//       title: '',
//       paragraphs: [''],
//     },
//     sections: {
//       whatWeOffer: '',
//       ourProcess: '',
//     },
//     offers: [{ icon: '', title: '', desc: '' }],
//     process: [{ icon: '', title: '', desc: '' }],
//     disclaimer: {
//       title: '',
//       text: '',
//     },
//     section3: {
//       title: '',
//       paragraphs: [''],
//     },
//   });

//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [successMessage, setSuccessMessage] = useState('');
//   const [existingHeroVideoUrl, setExistingHeroVideoUrl] = useState('');
//   const [existingTextBannerImageUrl, setExistingTextBannerImageUrl] = useState('');
//   const [existingTextBanner2ImageUrl, setExistingTextBanner2ImageUrl] = useState('');
//   const [existingDisclaimerVideoUrl, setExistingDisclaimerVideoUrl] = useState('');

//   useEffect(() => {
//     const fetchHomeBanner = async () => {
//       try {
//         const response = await axios.get(`${config.BASE_URL}/api/admin/architect-designer?includeSpanish=true`, {
//           withCredentials: true,
//           headers: {
//             'Content-Type': 'application/json',
//           },
//         });

//         if (response.data && response.data.data && response.data.data.length > 0) {
//           const data = response.data.data[0];
//           setContentId(data._id);
//           setIsNewContent(false);

//           setFormData({
//             hero: {
//               title: data.hero?.title || '',
//               subtitle: data.hero?.subtitle || '',
//               paragraphs: data.hero?.paragraphs?.length > 0 ? data.hero.paragraphs : [''],
//             },
//             statistics: {
//               ledStrips: { number: data.statistics?.ledStrips?.number || '',description: data.statistics?.ledStrips?.description || '' },
//               retailSpace: { number: data.statistics?.retailSpace?.number || '',description: data.statistics?.ledStrips?.description || '' },
//             },
//             navigation: {
//               aboutUs: data.navigation?.aboutUs || '',
//               ourTeam: data.navigation?.ourTeam || '',
//             },
//             textBanner: {
//               title: data.textBanner?.title || '',
//               paragraphs: data.textBanner?.paragraphs?.length > 0 ? data.textBanner.paragraphs : [''],
//             },
//             textBanner2: {
//               title: data.textBanner2?.title || '',
//               paragraphs: data.textBanner2?.paragraphs?.length > 0 ? data.textBanner2.paragraphs : [''],
//             },
//             sections: {
//               whatWeOffer: data.sections?.whatWeOffer || '',
//               ourProcess: data.sections?.ourProcess || '',
//             },
//             offers: data.offers?.length > 0 ? data.offers : [{ icon: '', title: '', desc: '' }],
//             process: data.process?.length > 0 ? data.process : [{ icon: '', title: '', desc: '' }],
//             disclaimer: {
//               title: data.disclaimer?.title || '',
//               text: data.disclaimer?.text || '',
//             },
//             section3: {
//               title: data.section3?.title || '',
//               paragraphs: data.section3?.paragraphs?.length > 0 ? data.section3.paragraphs : [''],
//             },
//           });

//           // Existing media URLs for preview
//           setExistingHeroVideoUrl(data.hero?.fileUrl || '');
//           setExistingTextBannerImageUrl('');
//           setExistingTextBanner2ImageUrl('');
//           setExistingDisclaimerVideoUrl('');

//           setSpanishData({
//             hero: {
//               title: data.spanishData?.hero?.title || '',
//               subtitle: data.spanishData?.hero?.subtitle || '',
//               paragraphs: data.spanishData?.hero?.paragraphs?.length > 0 ? data.spanishData.hero.paragraphs : [''],
//             },
//             statistics: {
//               ledStrips: { number: data.spanishData?.statistics?.ledStrips?.number || '',description: data.spanishData?.statistics?.ledStrips?.description || '' },
//               retailSpace: { number: data.spanishData?.statistics?.retailSpace?.number || '',description: data.spanishData?.statistics?.retailSpace?.description || '' },
//             },
//             navigation: {
//               aboutUs: data.spanishData?.navigation?.aboutUs || '',
//               ourTeam: data.spanishData?.navigation?.ourTeam || '',
//             },
//             textBanner: {
//               title: data.spanishData?.textBanner?.title || '',
//               paragraphs: data.spanishData?.textBanner?.paragraphs?.length > 0 ? data.spanishData.textBanner.paragraphs : [''],
//             },
//             textBanner2: {
//               title: data.spanishData?.textBanner2?.title || '',
//               paragraphs: data.spanishData?.textBanner2?.paragraphs?.length > 0 ? data.spanishData.textBanner2.paragraphs : [''],
//             },
//             sections: {
//               whatWeOffer: data.spanishData?.sections?.whatWeOffer || '',
//               ourProcess: data.spanishData?.sections?.ourProcess || '',
//             },
//             offers: data.spanishData?.offers?.length > 0 ? data.spanishData.offers : [{ icon: '', title: '', desc: '' }],
//             process: data.spanishData?.process?.length > 0 ? data.spanishData.process : [{ icon: '', title: '', desc: '' }],
//             disclaimer: {
//               title: data.spanishData?.disclaimer?.title || '',
//               text: data.spanishData?.disclaimer?.text || '',
//             },
//             section3: {
//               title: data.spanishData?.section3?.title || '',
//               paragraphs: data.spanishData?.section3?.paragraphs?.length > 0 ? data.spanishData.section3.paragraphs : [''],
//             },
//           });
//         } else {
//           setIsNewContent(true);
//         }
//       } catch (err) {
//         console.error('Error fetching home banner:', err);
//         if (err.response?.status === 404 || err.response?.status === 400) {
//           setIsNewContent(true);
//         } else if (err.response?.status === 401) {
//           setErrors({ submit: 'Authentication failed. Please login again.' });
//           setTimeout(() => navigate('/admin/login'), 2000);
//         } else {
//           setErrors({ submit: 'Failed to fetch home banner details' });
//         }
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchHomeBanner();
//   }, [navigate]);

//   // English Handlers
//   const handleHeroChange = (field, value) => {
//     setFormData(prev => ({
//       ...prev,
//       hero: { ...prev.hero, [field]: value },
//     }));
//   };

//   const handleHeroParagraphChange = (index, value) => {
//     const newParagraphs = [...formData.hero.paragraphs];
//     newParagraphs[index] = value;
//     setFormData(prev => ({
//       ...prev,
//       hero: { ...prev.hero, paragraphs: newParagraphs },
//     }));
//   };

//   const addHeroParagraph = () => {
//     setFormData(prev => ({
//       ...prev,
//       hero: { ...prev.hero, paragraphs: [...prev.hero.paragraphs, ''] },
//     }));
//   };

//   const removeHeroParagraph = (index) => {
//     if (formData.hero.paragraphs.length > 1) {
//       const newParagraphs = formData.hero.paragraphs.filter((_, i) => i !== index);
//       setFormData(prev => ({
//         ...prev,
//         hero: { ...prev.hero, paragraphs: newParagraphs },
//       }));
//     }
//   };

//   const handleNavigationChange = (field, value) => {
//     setFormData(prev => ({
//       ...prev,
//       navigation: { ...prev.navigation, [field]: value },
//     }));
//   };

//   const handleTextBannerChange = (field, value) => {
//     setFormData(prev => ({
//       ...prev,
//       textBanner: { ...prev.textBanner, [field]: value },
//     }));
//   };

//   const handleTextBannerParagraphChange = (index, value) => {
//     const newParagraphs = [...formData.textBanner.paragraphs];
//     newParagraphs[index] = value;
//     setFormData(prev => ({
//       ...prev,
//       textBanner: { ...prev.textBanner, paragraphs: newParagraphs },
//     }));
//   };

//   const addTextBannerParagraph = () => {
//     setFormData(prev => ({
//       ...prev,
//       textBanner: { ...prev.textBanner, paragraphs: [...prev.textBanner.paragraphs, ''] },
//     }));
//   };

//   const removeTextBannerParagraph = (index) => {
//     if (formData.textBanner.paragraphs.length > 1) {
//       const newParagraphs = formData.textBanner.paragraphs.filter((_, i) => i !== index);
//       setFormData(prev => ({
//         ...prev,
//         textBanner: { ...prev.textBanner, paragraphs: newParagraphs },
//       }));
//     }
//   };

//   const handleTextBanner2Change = (field, value) => {
//     setFormData(prev => ({
//       ...prev,
//       textBanner2: { ...prev.textBanner2, [field]: value },
//     }));
//   };

//   const handleTextBanner2ParagraphChange = (index, value) => {
//     const newParagraphs = [...formData.textBanner2.paragraphs];
//     newParagraphs[index] = value;
//     setFormData(prev => ({
//       ...prev,
//       textBanner2: { ...prev.textBanner2, paragraphs: newParagraphs },
//     }));
//   };

//   const addTextBanner2Paragraph = () => {
//     setFormData(prev => ({
//       ...prev,
//       textBanner2: { ...prev.textBanner2, paragraphs: [...prev.textBanner2.paragraphs, ''] },
//     }));
//   };

//   const removeTextBanner2Paragraph = (index) => {
//     if (formData.textBanner2.paragraphs.length > 1) {
//       const newParagraphs = formData.textBanner2.paragraphs.filter((_, i) => i !== index);
//       setFormData(prev => ({
//         ...prev,
//         textBanner2: { ...prev.textBanner2, paragraphs: newParagraphs },
//       }));
//     }
//   };

//   const handleSectionsChange = (field, value) => {
//     setFormData(prev => ({
//       ...prev,
//       sections: { ...prev.sections, [field]: value },
//     }));
//   };

//   const handleOfferChange = (index, field, value) => {
//     const newOffers = [...formData.offers];
//     newOffers[index] = { ...newOffers[index], [field]: value };
//     setFormData(prev => ({ ...prev, offers: newOffers }));
//   };

//   const addOffer = () => {
//     setFormData(prev => ({
//       ...prev,
//       offers: [...prev.offers, { icon: '', title: '', desc: '' }],
//     }));
//   };

//   const removeOffer = (index) => {
//     if (formData.offers.length > 1) {
//       const newOffers = formData.offers.filter((_, i) => i !== index);
//       setFormData(prev => ({ ...prev, offers: newOffers }));
//     }
//   };

//   const handleProcessChange = (index, field, value) => {
//     const newProcess = [...formData.process];
//     newProcess[index] = { ...newProcess[index], [field]: value };
//     setFormData(prev => ({ ...prev, process: newProcess }));
//   };

//   const addProcess = () => {
//     setFormData(prev => ({
//       ...prev,
//       process: [...prev.process, { icon: '', title: '', desc: '' }],
//     }));
//   };

//   const removeProcess = (index) => {
//     if (formData.process.length > 1) {
//       const newProcess = formData.process.filter((_, i) => i !== index);
//       setFormData(prev => ({ ...prev, process: newProcess }));
//     }
//   };

//   const handleDisclaimerChange = (field, value) => {
//     setFormData(prev => ({
//       ...prev,
//       disclaimer: { ...prev.disclaimer, [field]: value },
//     }));
//   };

//   const handleSection3Change = (field, value) => {
//     setFormData(prev => ({
//       ...prev,
//       section3: { ...prev.section3, [field]: value },
//     }));
//   };

//   const handleSection3ParagraphChange = (index, value) => {
//     const newParagraphs = [...formData.section3.paragraphs];
//     newParagraphs[index] = value;
//     setFormData(prev => ({
//       ...prev,
//       section3: { ...prev.section3, paragraphs: newParagraphs },
//     }));
//   };

//   const addSection3Paragraph = () => {
//     setFormData(prev => ({
//       ...prev,
//       section3: { ...prev.section3, paragraphs: [...prev.section3.paragraphs, ''] },
//     }));
//   };

//   const removeSection3Paragraph = (index) => {
//     if (formData.section3.paragraphs.length > 1) {
//       const newParagraphs = formData.section3.paragraphs.filter((_, i) => i !== index);
//       setFormData(prev => ({
//         ...prev,
//         section3: { ...prev.section3, paragraphs: newParagraphs },
//       }));
//     }
//   };

//   // Spanish Handlers
//   const handleStatisticsChange = (group, value) => {
//     setFormData(prev => ({
//       ...prev,
//       statistics: {
//         ...prev.statistics,
//         [group]: { number: value },
//       },
//     }));
//   };

//   const handleSpanishStatisticsChange = (group, value) => {
//     setSpanishData(prev => ({
//       ...prev,
//       statistics: {
//         ...prev.statistics,
//         [group]: { number: value },
//       },
//     }));
//   };
//    const handleStatisticsChangeDes = (group, value) => {
//     setFormData(prev => ({
//       ...prev,
//       statistics: {
//         ...prev.statistics,
//         [group]: { description: value },
//       },
//     }));
//   };

//   const handleSpanishStatisticsChangeDes = (group, value) => {
//     setSpanishData(prev => ({
//       ...prev,
//       statistics: {
//         ...prev.statistics,
//         [group]: { description: value },
//       },
//     }));
//   };
//   const handleSpanishHeroChange = (field, value) => {
//     setSpanishData(prev => ({
//       ...prev,
//       hero: { ...prev.hero, [field]: value },
//     }));
//   };

//   const handleSpanishHeroParagraphChange = (index, value) => {
//     const newParagraphs = [...spanishData.hero.paragraphs];
//     newParagraphs[index] = value;
//     setSpanishData(prev => ({
//       ...prev,
//       hero: { ...prev.hero, paragraphs: newParagraphs },
//     }));
//   };

//   const addSpanishHeroParagraph = () => {
//     setSpanishData(prev => ({
//       ...prev,
//       hero: { ...prev.hero, paragraphs: [...prev.hero.paragraphs, ''] },
//     }));
//   };

//   const removeSpanishHeroParagraph = (index) => {
//     if (spanishData.hero.paragraphs.length > 1) {
//       const newParagraphs = spanishData.hero.paragraphs.filter((_, i) => i !== index);
//       setSpanishData(prev => ({
//         ...prev,
//         hero: { ...prev.hero, paragraphs: newParagraphs },
//       }));
//     }
//   };

//   const handleSpanishNavigationChange = (field, value) => {
//     setSpanishData(prev => ({
//       ...prev,
//       navigation: { ...prev.navigation, [field]: value },
//     }));
//   };

//   const handleSpanishTextBannerChange = (field, value) => {
//     setSpanishData(prev => ({
//       ...prev,
//       textBanner: { ...prev.textBanner, [field]: value },
//     }));
//   };

//   const handleSpanishTextBannerParagraphChange = (index, value) => {
//     const newParagraphs = [...spanishData.textBanner.paragraphs];
//     newParagraphs[index] = value;
//     setSpanishData(prev => ({
//       ...prev,
//       textBanner: { ...prev.textBanner, paragraphs: newParagraphs },
//     }));
//   };

//   const addSpanishTextBannerParagraph = () => {
//     setSpanishData(prev => ({
//       ...prev,
//       textBanner: { ...prev.textBanner, paragraphs: [...prev.textBanner.paragraphs, ''] },
//     }));
//   };

//   const removeSpanishTextBannerParagraph = (index) => {
//     if (spanishData.textBanner.paragraphs.length > 1) {
//       const newParagraphs = spanishData.textBanner.paragraphs.filter((_, i) => i !== index);
//       setSpanishData(prev => ({
//         ...prev,
//         textBanner: { ...prev.textBanner, paragraphs: newParagraphs },
//       }));
//     }
//   };

//   const handleSpanishTextBanner2Change = (field, value) => {
//     setSpanishData(prev => ({
//       ...prev,
//       textBanner2: { ...prev.textBanner2, [field]: value },
//     }));
//   };

//   const handleSpanishTextBanner2ParagraphChange = (index, value) => {
//     const newParagraphs = [...spanishData.textBanner2.paragraphs];
//     newParagraphs[index] = value;
//     setSpanishData(prev => ({
//       ...prev,
//       textBanner2: { ...prev.textBanner2, paragraphs: newParagraphs },
//     }));
//   };

//   const addSpanishTextBanner2Paragraph = () => {
//     setSpanishData(prev => ({
//       ...prev,
//       textBanner2: { ...prev.textBanner2, paragraphs: [...prev.textBanner2.paragraphs, ''] },
//     }));
//   };

//   const removeSpanishTextBanner2Paragraph = (index) => {
//     if (spanishData.textBanner2.paragraphs.length > 1) {
//       const newParagraphs = spanishData.textBanner2.paragraphs.filter((_, i) => i !== index);
//       setSpanishData(prev => ({
//         ...prev,
//         textBanner2: { ...prev.textBanner2, paragraphs: newParagraphs },
//       }));
//     }
//   };

//   const handleSpanishSectionsChange = (field, value) => {
//     setSpanishData(prev => ({
//       ...prev,
//       sections: { ...prev.sections, [field]: value },
//     }));
//   };

//   const handleSpanishOfferChange = (index, field, value) => {
//     const newOffers = [...spanishData.offers];
//     newOffers[index] = { ...newOffers[index], [field]: value };
//     setSpanishData(prev => ({ ...prev, offers: newOffers }));
//   };

//   const addSpanishOffer = () => {
//     setSpanishData(prev => ({
//       ...prev,
//       offers: [...prev.offers, { icon: '', title: '', desc: '' }],
//     }));
//   };

//   const removeSpanishOffer = (index) => {
//     if (spanishData.offers.length > 1) {
//       const newOffers = spanishData.offers.filter((_, i) => i !== index);
//       setSpanishData(prev => ({ ...prev, offers: newOffers }));
//     }
//   };

//   const handleSpanishProcessChange = (index, field, value) => {
//     const newProcess = [...spanishData.process];
//     newProcess[index] = { ...newProcess[index], [field]: value };
//     setSpanishData(prev => ({ ...prev, process: newProcess }));
//   };

//   const addSpanishProcess = () => {
//     setSpanishData(prev => ({
//       ...prev,
//       process: [...prev.process, { icon: '', title: '', desc: '' }],
//     }));
//   };

//   const removeSpanishProcess = (index) => {
//     if (spanishData.process.length > 1) {
//       const newProcess = spanishData.process.filter((_, i) => i !== index);
//       setSpanishData(prev => ({ ...prev, process: newProcess }));
//     }
//   };

//   const handleSpanishDisclaimerChange = (field, value) => {
//     setSpanishData(prev => ({
//       ...prev,
//       disclaimer: { ...prev.disclaimer, [field]: value },
//     }));
//   };

//   const handleSpanishSection3Change = (field, value) => {
//     setSpanishData(prev => ({
//       ...prev,
//       section3: { ...prev.section3, [field]: value },
//     }));
//   };

//   const handleSpanishSection3ParagraphChange = (index, value) => {
//     const newParagraphs = [...spanishData.section3.paragraphs];
//     newParagraphs[index] = value;
//     setSpanishData(prev => ({
//       ...prev,
//       section3: { ...prev.section3, paragraphs: newParagraphs },
//     }));
//   };

//   const addSpanishSection3Paragraph = () => {
//     setSpanishData(prev => ({
//       ...prev,
//       section3: { ...prev.section3, paragraphs: [...prev.section3.paragraphs, ''] },
//     }));
//   };

//   const removeSpanishSection3Paragraph = (index) => {
//     if (spanishData.section3.paragraphs.length > 1) {
//       const newParagraphs = spanishData.section3.paragraphs.filter((_, i) => i !== index);
//       setSpanishData(prev => ({
//         ...prev,
//         section3: { ...prev.section3, paragraphs: newParagraphs },
//       }));
//     }
//   };

//   const validateForm = () => {
//     const newErrors = {};

//     // if (!formData.hero.title.trim()) newErrors['hero.title'] = 'Hero title is required';
//     // if (!formData.hero.subtitle.trim()) newErrors['hero.subtitle'] = 'Hero subtitle is required';
//     // if (!formData.navigation.aboutUs.trim()) newErrors['navigation.aboutUs'] = 'About Us navigation is required';
//     // if (!formData.navigation.ourTeam.trim()) newErrors['navigation.ourTeam'] = 'Our Team navigation is required';
//     // if (!formData.textBanner.title.trim()) newErrors['textBanner.title'] = 'Text Banner title is required';
//     // if (!formData.textBanner2.title.trim()) newErrors['textBanner2.title'] = 'Text Banner 2 title is required';
//     // if (!formData.sections.whatWeOffer.trim()) newErrors['sections.whatWeOffer'] = 'What We Offer section is required';
//     // if (!formData.sections.ourProcess.trim()) newErrors['sections.ourProcess'] = 'Our Process section is required';
//     // if (!formData.disclaimer.title.trim()) newErrors['disclaimer.title'] = 'Disclaimer title is required';
//     // if (!formData.disclaimer.text.trim()) newErrors['disclaimer.text'] = 'Disclaimer text is required';
//     // if (!formData.section3.title.trim()) newErrors['section3.title'] = 'Section 3 title is required';

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateForm()) return;

//     setIsSubmitting(true);
//     setErrors({});

//     try {
//       const fd = new FormData();

//       fd.append('hero', JSON.stringify({
//         title: formData.hero.title.trim(),
//         subtitle: formData.hero.subtitle.trim(),
//         paragraphs: formData.hero.paragraphs.filter(p => p.trim()).map(p => p.trim()),
//       }));

//       fd.append('statistics', JSON.stringify({
//         ledStrips: { number: String(formData.statistics.ledStrips.number).trim(),description: String(formData.statistics.ledStrips.description).trim() },
//         retailSpace: { number: String(formData.statistics.retailSpace.number).trim(),description: String(formData.statistics.retailSpace.description).trim() },
//       }));

//       // Optional Spanish translation
//       fd.append('spanishData', JSON.stringify({
//         hero: {
//           title: spanishData.hero.title.trim(),
//           subtitle: spanishData.hero.subtitle.trim(),
//           paragraphs: spanishData.hero.paragraphs.filter(p => p.trim()).map(p => p.trim()),
//         },
//         statistics: {
//           ledStrips: { number: String(spanishData.statistics.ledStrips.number).trim(),description: String(spanishData.statistics.ledStrips.description).trim() },
//           retailSpace: { number: String(spanishData.statistics.retailSpace.number).trim(),description: String(spanishData.statistics.retailSpace.description).trim() },
//         },
//       }));

//       // Files (optional)
//       if (heroVideoFile) fd.append('heroFile', heroVideoFile);
//       // Only heroFile supported for this page

//       let response;

//       if (isNewContent) {
//         response = await axios.post(`${config.BASE_URL}/api/admin/architect-designer`, fd, {
//           withCredentials: true,
//           headers: { 'Content-Type': 'multipart/form-data' },
//         });

//         if (response.status === 201) {
//           setContentId(response.data.data._id);
//           setIsNewContent(false);
//           setSuccessMessage('Architecture Designer content created successfully!');
//           const saved = response.data.data;
//           setExistingHeroVideoUrl(saved?.hero?.fileUrl || '');
//         }
//       } else {
//         response = await axios.put(`${config.BASE_URL}/api/admin/architect-designer/${contentId}`, fd, {
//           withCredentials: true,
//           headers: { 'Content-Type': 'multipart/form-data' },
//         });

//         if (response.status === 200) {
//           setSuccessMessage('Architecture Designer content updated successfully!');
//           const saved = response.data.data;
//           setExistingHeroVideoUrl(saved?.hero?.fileUrl || '');
//         }
//       }

//       setTimeout(() => setSuccessMessage(''), 3000);
//     } catch (err) {
//       console.error('Error saving home banner:', err);
//       let errorMessage = 'Failed to save home banner';
//       if (err.response?.data?.message) errorMessage = err.response.data.message;
//       else if (err.response?.status === 400) errorMessage = 'Invalid data provided';
//       else if (err.response?.status === 401) {
//         errorMessage = 'Authentication failed. Please login again.';
//         setTimeout(() => navigate('/admin/login'), 2000);
//       }
//       setErrors({ submit: errorMessage });
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   if (loading) {
//     return (
//       <div className="dashboard">
//         <div className="container">
//           <div className="main-section">
//             <div className="loading-container">
//               <div className="loading-spinner"></div>
//               <p className="text-white">Loading home banner...</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="dashboard">
//       <div className="container">
//         <h1 className="dash_title">Architecture & Designer Page</h1>
//         <div className="main-section">
//           <div className="back_btn_wrap">
//             <button className="back-btn" onClick={() => navigate(-1)}>Go Back</button>
//           </div>
//           <div className="main-inner add_project_main">
//             {/* <h2 style={{ marginBottom: '20px', color: '#fff' }}>
//               {isNewContent ? 'Create Home Banner' : 'Edit Home Banner'}
//             </h2> */}

//             {/* Language Tabs */}
//             <div className="language-tabs" style={{ marginBottom: '20px' }}>
//               <button
//                 type="button"
//                 onClick={() => setActiveLanguage('en')}
//                 style={{
//                   padding: '10px 20px',
//                   marginRight: '10px',
//                   backgroundColor: activeLanguage === 'en' ? '#007bff' : '#f8f9fa',
//                   color: activeLanguage === 'en' ? 'white' : 'black',
//                   border: '1px solid #ddd',
//                   cursor: 'pointer',
//                   borderRadius: '4px',
//                 }}
//               >
//                 English
//               </button>
//               <button
//                 type="button"
//                 onClick={() => setActiveLanguage('es')}
//                 style={{
//                   padding: '10px 20px',
//                   backgroundColor: activeLanguage === 'es' ? '#007bff' : '#f8f9fa',
//                   color: activeLanguage === 'es' ? 'white' : 'black',
//                   border: '1px solid #ddd',
//                   cursor: 'pointer',
//                   borderRadius: '4px',
//                 }}
//               >
//                 Spanish
//               </button>
//             </div>

//             <form onSubmit={handleSubmit}>
//               {successMessage && (
//                 <div
//                   style={{
//                     padding: '12px',
//                     marginBottom: '20px',
//                     backgroundColor: '#d4edda',
//                     border: '1px solid #c3e6cb',
//                     borderRadius: '4px',
//                     color: '#155724',
//                   }}
//                 >
//                   {successMessage}
//                 </div>
//               )}

//               {/* English Content */}
//               {activeLanguage === 'en' && (
//                 <div>
//                   <h3 style={{ color: '#fff', marginBottom: '20px' }}>English Content</h3>

//                   {/* Hero Section */}
//                   <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
//                     <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Banner Details</h4>
//                     <div className="add_field titleField">
//                       <h2>Title *</h2>
//                       <input
//                         type="text"
//                         value={formData.hero.title}
//                         onChange={(e) => handleHeroChange('title', e.target.value)}
//                         placeholder="Enter hero title"
//                         required
//                         disabled={isSubmitting}
//                       />
//                       {errors['hero.title'] && <p className="error-text">{errors['hero.title']}</p>}
//                     </div>
//                     <div className="add_field titleField">
//                       <h2>Subtitle *</h2>
//                       <input
//                         type="text"
//                         value={formData.hero.subtitle}
//                         onChange={(e) => handleHeroChange('subtitle', e.target.value)}
//                         placeholder="Enter hero subtitle"
//                         required
//                         disabled={isSubmitting}
//                       />
//                       {errors['hero.subtitle'] && <p className="error-text">{errors['hero.subtitle']}</p>}
//                     </div>
//                     <div>
//                       <h2>Paragraphs *</h2>
//                       {formData.hero.paragraphs.map((para, index) => (
//                         <div key={index} style={{ marginBottom: '10px' }} className="add_field titleField">
//                           <textarea
//                             value={para}
//                             onChange={(e) => handleHeroParagraphChange(index, e.target.value)}
//                             rows="3"
//                             placeholder={`Hero paragraph ${index + 1}`}
//                             disabled={isSubmitting}
//                           />
//                           {formData.hero.paragraphs.length > 1 && (
//                             <button
//                               type="button"
//                               onClick={() => removeHeroParagraph(index)}
//                               style={{
//                                 marginTop: '5px',
//                                 padding: '5px 15px',
//                                 backgroundColor: '#dc3545',
//                                 color: 'white',
//                                 border: 'none',
//                                 cursor: 'pointer',
//                                 borderRadius: '4px',
//                               }}
//                               disabled={isSubmitting}
//                             >
//                               Remove
//                             </button>
//                           )}
//                         </div>
//                       ))}
//                       <button
//                         type="button"
//                         onClick={addHeroParagraph}
//                         style={{
//                           padding: '8px 16px',
//                           backgroundColor: '#28a745',
//                           color: 'white',
//                           border: 'none',
//                           cursor: 'pointer',
//                           borderRadius: '4px',
//                         }}
//                         disabled={isSubmitting}
//                       >
//                         + Add Paragraph
//                       </button>
//                     </div>
//                     <div className="add_field titleField">
//                       <h2>Hero Video (optional)</h2>
//                       <input
//                         type="file"
//                         onChange={(e) => setHeroVideoFile(e.target.files && e.target.files[0] ? e.target.files[0] : null)}
//                         disabled={isSubmitting}
//                       />
//                       {(heroVideoFile || existingHeroVideoUrl) && (
//                         <div style={{ marginTop: '10px' }}>
//                           <video
//                             controls
//                             src={heroVideoFile ? URL.createObjectURL(heroVideoFile) : existingHeroVideoUrl}
//                             style={{ maxWidth: '100%', height: 'auto' }}
//                           />
//                         </div>
//                       )}
//                     </div>
//                   </div>


//                   <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
//                     <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Statistics</h4>
//                     <div className="add_field titleField">
//                       <h2>LED Strips Number</h2>
//                       <input
//                         type="text"
//                         value={formData.statistics.ledStrips.number}
//                         onChange={(e) => handleStatisticsChange('ledStrips', e.target.value)}
//                         placeholder="e.g., 10K+"
//                         disabled={isSubmitting}
//                       />
//                     </div>
//                      <div className="add_field titleField">
//                       <h2>LED Strips  Description</h2>
//                       <input
//                         type="text"
//                         value={formData.statistics.ledStrips.description}
//                         onChange={(e) => handleStatisticsChangeDes('ledStrips', e.target.value)}
//                         placeholder=""
//                         disabled={isSubmitting}
//                       />
//                     </div>
//                     <div className="add_field titleField">
//                       <h2>Retail Space Number</h2>
//                       <input
//                         type="text"
//                         value={formData.statistics.retailSpace.number}
//                         onChange={(e) => handleStatisticsChange('retailSpace', e.target.value)}
//                         placeholder="e.g., 50K+ sq ft"
//                         disabled={isSubmitting}
//                       />
//                     </div>
//                     <div className="add_field titleField">
//                       <h2>Retail Space Description</h2>
//                       <input
//                         type="text"
//                         value={formData.statistics.retailSpace.description}
//                         onChange={(e) => handleStatisticsChangeDes('retailSpace', e.target.value)}
//                         placeholder=""
//                         disabled={isSubmitting}
//                       />
//                     </div>
//                   </div>

//                 </div>
//               )}
//               {activeLanguage === 'es' && (
//                 <div>
//                   <h3 style={{ color: '#fff', marginBottom: '20px' }}>Spanish Content (Contenido en Español)</h3>

//                   <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
//                     <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Banner Details</h4>
//                     <div className="add_field titleField">
//                       <h2>Título</h2>
//                       <input
//                         type="text"
//                         value={spanishData.hero.title}
//                         onChange={(e) => handleSpanishHeroChange('title', e.target.value)}
//                         placeholder="Ingrese el título del hero"
//                         disabled={isSubmitting}
//                       />
//                     </div>
//                     <div className="add_field titleField">
//                       <h2>Subtítulo</h2>
//                       <input
//                         type="text"
//                         value={spanishData.hero.subtitle}
//                         onChange={(e) => handleSpanishHeroChange('subtitle', e.target.value)}
//                         placeholder="Ingrese el subtítulo del hero"
//                         disabled={isSubmitting}
//                       />
//                     </div>
//                     <div>
//                       <h2>Párrafos</h2>
//                       {spanishData.hero.paragraphs.map((para, index) => (
//                         <div key={index} style={{ marginBottom: '10px' }} className="add_field titleField">
//                           <textarea
//                             value={para}
//                             onChange={(e) => handleSpanishHeroParagraphChange(index, e.target.value)}
//                             rows="3"
//                             placeholder={`Párrafo ${index + 1}`}
//                             disabled={isSubmitting}
//                           />
//                           {spanishData.hero.paragraphs.length > 1 && (
//                             <button
//                               type="button"
//                               onClick={() => removeSpanishHeroParagraph(index)}
//                               style={{
//                                 marginTop: '5px',
//                                 padding: '5px 15px',
//                                 backgroundColor: '#dc3545',
//                                 color: 'white',
//                                 border: 'none',
//                                 cursor: 'pointer',
//                                 borderRadius: '4px',
//                               }}
//                               disabled={isSubmitting}
//                             >
//                               Eliminar
//                             </button>
//                           )}
//                         </div>
//                       ))}
//                       <button
//                         type="button"
//                         onClick={addSpanishHeroParagraph}
//                         style={{
//                           padding: '8px 16px',
//                           backgroundColor: '#28a745',
//                           color: 'white',
//                           border: 'none',
//                           cursor: 'pointer',
//                           borderRadius: '4px',
//                         }}
//                         disabled={isSubmitting}
//                       >
//                         + Agregar Párrafo
//                       </button>
//                     </div>
//                   </div>



//                   <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
//                     <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Estadísticas</h4>
//                     <div className="add_field titleField">
//                       <h2>Tiras LED</h2>
//                       <input
//                         type="text"
//                         value={spanishData.statistics.ledStrips.number}
//                         onChange={(e) => handleSpanishStatisticsChange('ledStrips', e.target.value)}
//                         placeholder="p.ej., 10K+"
//                         disabled={isSubmitting}
//                       />
//                     </div>
//                     <div className="add_field titleField">
//                       <h2>Tiras LED Description</h2>
//                       <input
//                         type="text"
//                         value={spanishData.statistics.ledStrips.description}
//                         onChange={(e) => handleSpanishStatisticsChangeDes('ledStrips', e.target.value)}
//                         placeholder="p.ej., 10K+"
//                         disabled={isSubmitting}
//                       />
//                     </div>
//                     <div className="add_field titleField">
//                       <h2>Espacio Retail</h2>
//                       <input
//                         type="text"
//                         value={spanishData.statistics.retailSpace.number}
//                         onChange={(e) => handleSpanishStatisticsChange('retailSpace', e.target.value)}
//                         placeholder="p.ej., 50K+ m²"
//                         disabled={isSubmitting}
//                       />
//                     </div>
//                       <div className="add_field titleField">
//                       <h2>Espacio Retail Description</h2>
//                       <input
//                         type="text"
//                         value={spanishData.statistics.retailSpace.description}
//                         onChange={(e) => handleSpanishStatisticsChangeDes('retailSpace', e.target.value)}
//                         placeholder="p.ej., 50K+ m²"
//                         disabled={isSubmitting}
//                       />
//                     </div>
//                   </div>

//                 </div>
//               )}

//               <div className="add_project" style={{ marginTop: '30px' }}>
//                 <button type="submit" disabled={isSubmitting} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                   <Save className="w-5 h-5" />
//                   {isSubmitting ? 'Saving...' : isNewContent ? 'Save' : 'Save'}
//                 </button>
//               </div>
//             </form>

//             {errors.submit && (
//               <div
//                 style={{
//                   padding: '12px',
//                   marginTop: '20px',
//                   backgroundColor: '#f8d7da',
//                   border: '1px solid #f5c6cb',
//                   borderRadius: '4px',
//                   color: '#721c24',
//                 }}
//               >
//                 {errors.submit}
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ArchitectureDesignerPageManage;













import React, { useState, useEffect } from 'react';
import { Save, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import config from '../../config';
import axios from 'axios';

const ArchitectureDesignerPageManage = () => {
  const navigate = useNavigate();

  const [activeLanguage, setActiveLanguage] = useState('en');
  const [contentId, setContentId] = useState(null);
  const [isNewContent, setIsNewContent] = useState(false);

  // English form data
  const [formData, setFormData] = useState({
    hero: {
      title: '',
      subtitle: '',
      paragraphs: [''],
    },
    statistics: {
      ledStrips: { number: '', description: '' },
      retailSpace: { number: '', description: '' },
    },
  });

  // Spanish translation form data
  const [spanishData, setSpanishData] = useState({
    hero: {
      title: '',
      subtitle: '',
      paragraphs: [''],
    },
    statistics: {
      ledStrips: { number: '', description: '' },
      retailSpace: { number: '', description: '' },
    },
  });

  // Upload file (hero video)
  const [heroVideoFile, setHeroVideoFile] = useState(null);
  const [existingHeroVideoUrl, setExistingHeroVideoUrl] = useState('');

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    const fetchHomeBanner = async () => {
      try {
        const response = await axios.get(`${config.BASE_URL}/api/admin/architect-designer?includeSpanish=true`, {
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (response.data && response.data.data && response.data.data.length > 0) {
          const data = response.data.data[0];
          setContentId(data._id);
          setIsNewContent(false);

          setFormData({
            hero: {
              title: data.hero?.title || '',
              subtitle: data.hero?.subtitle || '',
              paragraphs: data.hero?.paragraphs?.length > 0 ? data.hero.paragraphs : [''],
            },
            statistics: {
              ledStrips: { number: data.statistics?.ledStrips?.number || '', description: data.statistics?.ledStrips?.description || '' },
              retailSpace: { number: data.statistics?.retailSpace?.number || '', description: data.statistics?.retailSpace?.description || '' },
            },
          });

          setExistingHeroVideoUrl(data.hero?.fileUrl || '');

          setSpanishData({
            hero: {
              title: data.spanishData?.hero?.title || '',
              subtitle: data.spanishData?.hero?.subtitle || '',
              paragraphs: data.spanishData?.hero?.paragraphs?.length > 0 ? data.spanishData.hero.paragraphs : [''],
            },
            statistics: {
              ledStrips: { number: data.spanishData?.statistics?.ledStrips?.number || '', description: data.spanishData?.statistics?.ledStrips?.description || '' },
              retailSpace: { number: data.spanishData?.statistics?.retailSpace?.number || '', description: data.spanishData?.statistics?.retailSpace?.description || '' },
            },
          });
        } else {
          setIsNewContent(true);
        }
      } catch (err) {
        console.error('Error fetching home banner:', err);
        if (err.response?.status === 404 || err.response?.status === 400) {
          setIsNewContent(true);
        } else if (err.response?.status === 401) {
          setErrors({ submit: 'Authentication failed. Please login again.' });
          setTimeout(() => navigate('/admin/login'), 2000);
        } else {
          setErrors({ submit: 'Failed to fetch home banner details' });
        }
      } finally {
        setLoading(false);
      }
    };

    fetchHomeBanner();
  }, [navigate]);

  // English Handlers
  const handleHeroChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      hero: { ...prev.hero, [field]: value },
    }));
  };

  const handleHeroParagraphChange = (index, value) => {
    const newParagraphs = [...formData.hero.paragraphs];
    newParagraphs[index] = value;
    setFormData(prev => ({
      ...prev,
      hero: { ...prev.hero, paragraphs: newParagraphs },
    }));
  };

  const addHeroParagraph = () => {
    setFormData(prev => ({
      ...prev,
      hero: { ...prev.hero, paragraphs: [...prev.hero.paragraphs, ''] },
    }));
  };

  const removeHeroParagraph = (index) => {
    if (formData.hero.paragraphs.length > 1) {
      const newParagraphs = formData.hero.paragraphs.filter((_, i) => i !== index);
      setFormData(prev => ({
        ...prev,
        hero: { ...prev.hero, paragraphs: newParagraphs },
      }));
    }
  };

  const handleStatisticsChange = (group, field, value) => {
    setFormData(prev => ({
      ...prev,
      statistics: {
        ...prev.statistics,
        [group]: { ...prev.statistics[group], [field]: value },
      },
    }));
  };

  // Spanish Handlers
  const handleSpanishHeroChange = (field, value) => {
    setSpanishData(prev => ({
      ...prev,
      hero: { ...prev.hero, [field]: value },
    }));
  };

  const handleSpanishHeroParagraphChange = (index, value) => {
    const newParagraphs = [...spanishData.hero.paragraphs];
    newParagraphs[index] = value;
    setSpanishData(prev => ({
      ...prev,
      hero: { ...prev.hero, paragraphs: newParagraphs },
    }));
  };

  const addSpanishHeroParagraph = () => {
    setSpanishData(prev => ({
      ...prev,
      hero: { ...prev.hero, paragraphs: [...prev.hero.paragraphs, ''] },
    }));
  };

  const removeSpanishHeroParagraph = (index) => {
    if (spanishData.hero.paragraphs.length > 1) {
      const newParagraphs = spanishData.hero.paragraphs.filter((_, i) => i !== index);
      setSpanishData(prev => ({
        ...prev,
        hero: { ...prev.hero, paragraphs: newParagraphs },
      }));
    }
  };

  const handleSpanishStatisticsChange = (group, field, value) => {
    setSpanishData(prev => ({
      ...prev,
      statistics: {
        ...prev.statistics,
        [group]: { ...prev.statistics[group], [field]: value },
      },
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.hero.title.trim()) newErrors['hero.title'] = 'Hero title is required';
    if (!formData.hero.subtitle.trim()) newErrors['hero.subtitle'] = 'Hero subtitle is required';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setIsSubmitting(true);
    setErrors({});

    try {
      const fd = new FormData();

      fd.append('hero', JSON.stringify({
        title: formData.hero.title.trim(),
        subtitle: formData.hero.subtitle.trim(),
        paragraphs: formData.hero.paragraphs.filter(p => p.trim()).map(p => p.trim()),
      }));

      fd.append('statistics', JSON.stringify({
        ledStrips: {
          number: String(formData.statistics.ledStrips.number).trim(),
          description: String(formData.statistics.ledStrips.description).trim(),
        },
        retailSpace: {
          number: String(formData.statistics.retailSpace.number).trim(),
          description: String(formData.statistics.retailSpace.description).trim(),
        },
      }));

      // Spanish translation
      fd.append('spanishData', JSON.stringify({
        hero: {
          title: spanishData.hero.title.trim(),
          subtitle: spanishData.hero.subtitle.trim(),
          paragraphs: spanishData.hero.paragraphs.filter(p => p.trim()).map(p => p.trim()),
        },
        statistics: {
          ledStrips: {
            number: String(spanishData.statistics.ledStrips.number).trim(),
            description: String(spanishData.statistics.ledStrips.description).trim(),
          },
          retailSpace: {
            number: String(spanishData.statistics.retailSpace.number).trim(),
            description: String(spanishData.statistics.retailSpace.description).trim(),
          },
        },
      }));

      if (heroVideoFile) fd.append('heroFile', heroVideoFile);

      let response;

      if (isNewContent) {
        response = await axios.post(`${config.BASE_URL}/api/admin/architect-designer`, fd, {
          withCredentials: true,
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        if (response.status === 201) {
          setContentId(response.data.data._id);
          setIsNewContent(false);
          setSuccessMessage('Architecture Designer content created successfully!');
          const saved = response.data.data;
          setExistingHeroVideoUrl(saved?.hero?.fileUrl || '');
        }
      } else {
        response = await axios.put(`${config.BASE_URL}/api/admin/architect-designer/${contentId}`, fd, {
          withCredentials: true,
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        if (response.status === 200) {
          setSuccessMessage('Architecture Designer content updated successfully!');
          const saved = response.data.data;
          setExistingHeroVideoUrl(saved?.hero?.fileUrl || '');
        }
      }

      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (err) {
      console.error('Error saving home banner:', err);
      let errorMessage = 'Failed to save home banner';
      if (err.response?.data?.message) errorMessage = err.response.data.message;
      else if (err.response?.status === 400) errorMessage = 'Invalid data provided';
      else if (err.response?.status === 401) {
        errorMessage = 'Authentication failed. Please login again.';
        setTimeout(() => navigate('/admin/login'), 2000);
      }
      setErrors({ submit: errorMessage });
    } finally {
      setIsSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className="dashboard">
        <div className="container">
          <div className="main-section">
            <div className="loading-container">
              <div className="loading-spinner"></div>
              <p className="text-white">Loading home banner...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard">
      <div className="container">
        <h1 className="dash_title">Architecture & Designer Page</h1>
        <div className="main-section">
          <div className="back_btn_wrap">
            <button className="back-btn" onClick={() => navigate(-1)}>Go Back</button>
          </div>
          <div className="main-inner add_project_main">
            <div className="language-tabs" style={{ marginBottom: '20px' }}>
              <button
                type="button"
                onClick={() => setActiveLanguage('en')}
                style={{
                  padding: '10px 20px',
                  marginRight: '10px',
                  backgroundColor: activeLanguage === 'en' ? '#007bff' : '#f8f9fa',
                  color: activeLanguage === 'en' ? 'white' : 'black',
                  border: '1px solid #ddd',
                  cursor: 'pointer',
                  borderRadius: '4px',
                }}
              >
                English
              </button>
              <button
                type="button"
                onClick={() => setActiveLanguage('es')}
                style={{
                  padding: '10px 20px',
                  backgroundColor: activeLanguage === 'es' ? '#007bff' : '#f8f9fa',
                  color: activeLanguage === 'es' ? 'white' : 'black',
                  border: '1px solid #ddd',
                  cursor: 'pointer',
                  borderRadius: '4px',
                }}
              >
                Spanish
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              {successMessage && (
                <div
                  style={{
                    padding: '12px',
                    marginBottom: '20px',
                    backgroundColor: '#d4edda',
                    border: '1px solid #c3e6cb',
                    borderRadius: '4px',
                    color: '#155724',
                  }}
                >
                  {successMessage}
                </div>
              )}

              {activeLanguage === 'en' && (
                <div>
                  <h3 style={{ color: '#fff', marginBottom: '20px' }}>English Content</h3>

                  <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
                    <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Banner Details</h4>
                    <div className="add_field titleField">
                      <h2>Title *</h2>
                      <input
                        type="text"
                        value={formData.hero.title}
                        onChange={(e) => handleHeroChange('title', e.target.value)}
                        placeholder="Enter hero title"
                        required
                        disabled={isSubmitting}
                      />
                      {errors['hero.title'] && <p className="error-text">{errors['hero.title']}</p>}
                    </div>
                    <div className="add_field titleField">
                      <h2>Subtitle *</h2>
                      <input
                        type="text"
                        value={formData.hero.subtitle}
                        onChange={(e) => handleHeroChange('subtitle', e.target.value)}
                        placeholder="Enter hero subtitle"
                        required
                        disabled={isSubmitting}
                      />
                      {errors['hero.subtitle'] && <p className="error-text">{errors['hero.subtitle']}</p>}
                    </div>
                    <div>
                      <h2>Paragraphs</h2>
                      {formData.hero.paragraphs.map((para, index) => (
                        <div key={index} style={{ marginBottom: '10px' }} className="add_field titleField">
                          <textarea
                            value={para}
                            onChange={(e) => handleHeroParagraphChange(index, e.target.value)}
                            rows="3"
                            placeholder={`Hero paragraph ${index + 1}`}
                            disabled={isSubmitting}
                          />
                          {formData.hero.paragraphs.length > 1 && (
                            <button
                              type="button"
                              onClick={() => removeHeroParagraph(index)}
                              style={{
                                marginTop: '5px',
                                padding: '5px 15px',
                                backgroundColor: '#dc3545',
                                color: 'white',
                                border: 'none',
                                cursor: 'pointer',
                                borderRadius: '4px',
                              }}
                              disabled={isSubmitting}
                            >
                              Remove
                            </button>
                          )}
                        </div>
                      ))}
                      <button
                        type="button"
                        onClick={addHeroParagraph}
                        style={{
                          padding: '8px 16px',
                          backgroundColor: '#28a745',
                          color: 'white',
                          border: 'none',
                          cursor: 'pointer',
                          borderRadius: '4px',
                        }}
                        disabled={isSubmitting}
                      >
                        + Add Paragraph
                      </button>
                    </div>
                    <div className="add_field titleField">
                      <h2>Hero Video/Image</h2>
                      <input
                        type="file"
                        onChange={(e) => setHeroVideoFile(e.target.files && e.target.files[0] ? e.target.files[0] : null)}
                        disabled={isSubmitting}
                      />
                      {(heroVideoFile || existingHeroVideoUrl) && (
                        // <div style={{ marginTop: '10px' }}>
                        //   <video
                        //     controls
                        //     src={heroVideoFile ? URL.createObjectURL(heroVideoFile) : existingHeroVideoUrl}
                        //     style={{ maxWidth: '100%', height: 'auto' }}
                        //   />
                        // </div>
                        <div style={{ marginTop: '10px' }} className='wid-150'>
                          {/* {heroVideoFile?.type?. (existingHeroVideoUrl && existingHeroVideoUrl.match(/\.(mp4|webm|ogg)$/i)) ? (
                            <video
                              controls
                              src={heroVideoFile ? URL.createObjectURL(heroVideoFile) : config.BASE_URL+'/'+existingHeroVideoUrl}
                              style={{ maxWidth: '100%', height: 'auto' }}
                            />
                          ) : (
                            <img
                              src={heroVideoFile ? URL.createObjectURL(heroVideoFile) : config.BASE_URL+'/'+existingHeroVideoUrl}
                              alt="Hero"
                              style={{ maxWidth: '100%', height: 'auto' }}
                            />
                          )} */}
                          <div style={{ marginTop: '10px' }} className='wid-150'>
                            {(heroVideoFile?.type?.startsWith('video/') || (existingHeroVideoUrl && existingHeroVideoUrl.match(/\.(mp4|webm|ogg)$/i))) ? (
                              <video
                                controls
                                src={heroVideoFile ? URL.createObjectURL(heroVideoFile) : config.BASE_URL + '/' + existingHeroVideoUrl}
                                style={{ maxWidth: '100%', height: 'auto' }}
                              />
                            ) : (
                              <img
                                src={heroVideoFile ? URL.createObjectURL(heroVideoFile) : config.BASE_URL + '/' + existingHeroVideoUrl}
                                alt="Hero"
                                style={{ maxWidth: '100%', height: 'auto' }}
                              />
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
                    <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Statistics</h4>
                    <div className="add_field titleField">
                      <h2>LED Strips Number</h2>
                      <input
                        type="text"
                        value={formData.statistics.ledStrips.number}
                        onChange={(e) => handleStatisticsChange('ledStrips', 'number', e.target.value)}
                        placeholder="e.g., 10K+"
                        disabled={isSubmitting}
                      />
                    </div>
                    <div className="add_field titleField">
                      <h2>LED Strips Description</h2>
                      <input
                        type="text"
                        value={formData.statistics.ledStrips.description}
                        onChange={(e) => handleStatisticsChange('ledStrips', 'description', e.target.value)}
                        placeholder="Enter LED strips description"
                        disabled={isSubmitting}
                      />
                    </div>
                    <div className="add_field titleField">
                      <h2>Retail Space Number</h2>
                      <input
                        type="text"
                        value={formData.statistics.retailSpace.number}
                        onChange={(e) => handleStatisticsChange('retailSpace', 'number', e.target.value)}
                        placeholder="e.g., 50K+ sq ft"
                        disabled={isSubmitting}
                      />
                    </div>
                    <div className="add_field titleField">
                      <h2>Retail Space Description</h2>
                      <input
                        type="text"
                        value={formData.statistics.retailSpace.description}
                        onChange={(e) => handleStatisticsChange('retailSpace', 'description', e.target.value)}
                        placeholder="Enter retail space description"
                        disabled={isSubmitting}
                      />
                    </div>
                  </div>
                </div>
              )}

              {activeLanguage === 'es' && (
                <div>
                  <h3 style={{ color: '#fff', marginBottom: '20px' }}>Spanish Content (Contenido en Español)</h3>

                  <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
                    <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Banner Details</h4>
                    <div className="add_field titleField">
                      <h2>Título</h2>
                      <input
                        type="text"
                        value={spanishData.hero.title}
                        onChange={(e) => handleSpanishHeroChange('title', e.target.value)}
                        placeholder="Ingrese el título del hero"
                        disabled={isSubmitting}
                      />
                    </div>
                    <div className="add_field titleField">
                      <h2>Subtítulo</h2>
                      <input
                        type="text"
                        value={spanishData.hero.subtitle}
                        onChange={(e) => handleSpanishHeroChange('subtitle', e.target.value)}
                        placeholder="Ingrese el subtítulo del hero"
                        disabled={isSubmitting}
                      />
                    </div>
                    <div>
                      <h2>Párrafos</h2>
                      {spanishData.hero.paragraphs.map((para, index) => (
                        <div key={index} style={{ marginBottom: '10px' }} className="add_field titleField">
                          <textarea
                            value={para}
                            onChange={(e) => handleSpanishHeroParagraphChange(index, e.target.value)}
                            rows="3"
                            placeholder={`Párrafo ${index + 1}`}
                            disabled={isSubmitting}
                          />
                          {spanishData.hero.paragraphs.length > 1 && (
                            <button
                              type="button"
                              onClick={() => removeSpanishHeroParagraph(index)}
                              style={{
                                marginTop: '5px',
                                padding: '5px 15px',
                                backgroundColor: '#dc3545',
                                color: 'white',
                                border: 'none',
                                cursor: 'pointer',
                                borderRadius: '4px',
                              }}
                              disabled={isSubmitting}
                            >
                              Eliminar
                            </button>
                          )}
                        </div>
                      ))}
                      <button
                        type="button"
                        onClick={addSpanishHeroParagraph}
                        style={{
                          padding: '8px 16px',
                          backgroundColor: '#28a745',
                          color: 'white',
                          border: 'none',
                          cursor: 'pointer',
                          borderRadius: '4px',
                        }}
                        disabled={isSubmitting}
                      >
                        + Agregar Párrafo
                      </button>
                    </div>
                  </div>

                  <div className="section-group" style={{ marginBottom: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
                    <h4 style={{ color: '#ffd700', marginBottom: '15px', fontSize: '18px' }}>Estadísticas</h4>
                    <div className="add_field titleField">
                      <h2>Tiras LED</h2>
                      <input
                        type="text"
                        value={spanishData.statistics.ledStrips.number}
                        onChange={(e) => handleSpanishStatisticsChange('ledStrips', 'number', e.target.value)}
                        placeholder="p.ej., 10K+"
                        disabled={isSubmitting}
                      />
                      تھ

                    </div>
                    <div className="add_field titleField">
                      <h2>Tiras LED Descripción</h2>
                      <input
                        type="text"
                        value={spanishData.statistics.ledStrips.description}
                        onChange={(e) => handleSpanishStatisticsChange('ledStrips', 'description', e.target.value)}
                        placeholder="Ingrese la descripción de las tiras LED"
                        disabled={isSubmitting}
                      />
                    </div>
                    <div className="add_field titleField">
                      <h2>Espacio Retail</h2>
                      <input
                        type="text"
                        value={spanishData.statistics.retailSpace.number}
                        onChange={(e) => handleSpanishStatisticsChange('retailSpace', 'number', e.target.value)}
                        placeholder="p.ej., 50K+ m²"
                        disabled={isSubmitting}
                      />
                    </div>
                    <div className="add_field titleField">
                      <h2>Espacio Retail Descripción</h2>
                      <input
                        type="text"
                        value={spanishData.statistics.retailSpace.description}
                        onChange={(e) => handleSpanishStatisticsChange('retailSpace', 'description', e.target.value)}
                        placeholder="Ingrese la descripción del espacio retail"
                        disabled={isSubmitting}
                      />
                    </div>
                  </div>
                </div>
              )}

              <div className="add_project" style={{ marginTop: '30px' }}>
                <button type="submit" disabled={isSubmitting} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Save className="w-5 h-5" />
                  {isSubmitting ? 'Saving...' : isNewContent ? 'Save' : 'Save'}
                </button>
              </div>
            </form>

            {errors.submit && (
              <div
                style={{
                  padding: '12px',
                  marginTop: '20px',
                  backgroundColor: '#f8d7da',
                  border: '1px solid #f5c6cb',
                  borderRadius: '4px',
                  color: '#721c24',
                }}
              >
                {errors.submit}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArchitectureDesignerPageManage;